export default "__VITE_ASSET__4dcbe245__"